import { APPLICANT_STAGE } from '../../../../../RentalPortalApplicant'

export const QA_NAME_MATCH_REQUEST_INFO = 'matchRequestInfo'

export const MATCH_REQUEST_THROTTLE_HOURS = 24

export const MATCH_REQUEST_HIDDEN_STAGES = [
  APPLICANT_STAGE.selected,
  APPLICANT_STAGE.approved,
  APPLICANT_STAGE.rejected,
  APPLICANT_STAGE.withdrawn,
]

export const QA_NAME_MATCH_RULES_LINK = 'matchRulesLink'
